import { render } from "./GalleryProduct.vue?vue&type=template&id=36c82a1e"
import script from "./GalleryProduct.vue?vue&type=script&lang=js"
export * from "./GalleryProduct.vue?vue&type=script&lang=js"

import "./GalleryProduct.vue?vue&type=style&index=0&id=36c82a1e&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__